// extracted by mini-css-extract-plugin
export default {"grid":"HeaderInvoice_grid__LVv5E","row":"HeaderInvoice_row__MuJR1","title":"HeaderInvoice_title__6tWGZ"};